import RolesChecker from 'features/customer/components/RolesChecker';
import RenderWrapper from 'features/shared/components/renderWrapper/RenderWrapper';
import { loadPortalConfig } from 'features/shared/helpers/modules';
import { Contracts_Invoice_Simulation_Route } from 'features/shared/router/routes/routes';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const portalConfig = loadPortalConfig();

type Props = {}

const InvoiceSimulationButton = (props: Props) => {
  // translations
  const tLabels = useTranslation("contracts\\contracts").t;

  // render
  return (
    <RenderWrapper isVisible={() => portalConfig.enableInvoiceSimulation}>
      <RolesChecker enabledRoles="Contributor">
        <Link
          className="btn btn-sm btn-secondary"
          to={`/${Contracts_Invoice_Simulation_Route}`}
        >
          <span className="d-none d-sm-inline">{tLabels("contractsSection.invoiceSimulation.desktop")}</span>
          <span className="d-sm-none">{tLabels("contractsSection.invoiceSimulation.mobile")}</span>
        </Link>
      </RolesChecker>
    </RenderWrapper>
  );
}

export default InvoiceSimulationButton;